import gql from 'graphql-tag';

export type ApplicationEventAggregatesVariables = {
  fieldId: string;
};

const MACHINE_DATA_BY_FIELD = gql`
  query FIELD_APPLICATION_EVENT_AGGREGATES(
    $fieldId: ID!
  ) {
    machineDataByFieldId(id: $fieldId) {
      id
      applicationEventAggregates {
        events {
          name
          firstApplicationDateTime
          lastApplicationDateTime
          seasonName
          seasonYear
          legacySeasonTag
          area {
            u
            v
          }
          averageApplicationRate {
            u
            v
          }
          averageMachineSpeed {
            u
            v
          }
          chemicalProductsApplied {
            rate {
              u
              v
            }
            amountApplied {
              u
              v
            }
            area {
              u
              v
            }
            growerAmountUnit
            chemicalProduct {
              id
              name
            }
          }
        }
      }
    }
  }
`;

export const getApplicationEventAggregates = (
  variables: ApplicationEventAggregatesVariables
) => ({
  query: MACHINE_DATA_BY_FIELD,
  variables,
});
